/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_Lesuur_ToevoegenInputs */

const nl_planning_rooster_lesuur_toevoegen = /** @type {(inputs: Planning_Rooster_Lesuur_ToevoegenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesuur`)
};

/**

* @param {Planning_Rooster_Lesuur_ToevoegenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_lesuur_toevoegen = /** @type {((inputs?: Planning_Rooster_Lesuur_ToevoegenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Lesuur_ToevoegenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_lesuur_toevoegen(inputs)
});
export { planning_rooster_lesuur_toevoegen as "planning.rooster.lesuur_toevoegen" }